import { Button } from "Components/TextContext/commonComponentEnums";
import {
  findCountry,
  getNoItemsFoundText,
  mapToCountries,
  mapToSearchItems,
} from "./akaStudentProductIntroUtils";

import { Autosuggest } from "Components/Form/Autosuggest";
import { useTexts } from "Components/TextContext";
import { useAkaStudentCountries } from "Store/texts/hooks";
import { getError } from "Utils/productUtils";
import { useFormikContext } from "formik";
import React from "react";
import { AkaStudentProductIntroFormValues } from "./akaStudentProductIntroInterfaces";

export const AkaStudentProductIntroFormElements = (): React.ReactElement => {
  const formProps = useFormikContext<AkaStudentProductIntroFormValues>();
  const { getText } = useTexts();
  const { optionsList } = useAkaStudentCountries();
  const countries = mapToCountries(optionsList);
  const options = mapToSearchItems(optionsList);

  const setCountryRegion = (countryName: string | undefined): void => {
    const country = findCountry(countryName, countries);
    country && formProps.setFieldValue("region", country.code);
  };

  return (
    <>
      <Autosuggest
        id="country"
        name="country"
        label={getText("akastudentform.label.country")}
        hint={getText("akastudentform.hint.country")}
        hintProps={{
          maxLines: 5,
          readLessLabel: getText(Button.READ_LESS),
          readMoreLabel: getText(Button.READ_MORE),
        }}
        data={options}
        error={getError("country", formProps)}
        onItemSelect={(_, option) => {
          setCountryRegion(option?.value);
        }}
        noItemFoundText={getNoItemsFoundText(formProps)}
      />
    </>
  );
};
